import React from 'react';
import PropTypes from 'prop-types';

const Modal = ({ ...props }) => {
  Modal.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    percentage: PropTypes.number,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]).isRequired
  };

  if (!props.show) {
    return null;
  }

  return (
  // TODO make modal window header flexable to window size as header work throughout app
    <div className='modal-backdrop'
      // style={backdropStyle}
    >
      <div className='modal-window'>
        <div className='modal-header-block'>
          <div>
            <i
              className='material-icons material-icons-close font-size-big text-white'
              aria-hidden='true'
              onClick={props.onClose}
            />
          </div>
          <div className='text-white modal-header-text'>
            {props.title}
          </div>
        </div>
        <div className='modal-body-wrapper'>
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
